import { getAuth, postAuth, postRaw } from "./client";
import type { User } from "../types/user";

interface AuthResponse {
  data: User;
}

export async function login(email: string, password: string): Promise<User> {
  const response = await postAuth<AuthResponse>("/api/auth/login", { email, password });
  return response.data;
}

export async function signup(displayName: string, email: string, password: string): Promise<void> {
  await postAuth<unknown>("/api/auth/signup", {
    display_name: displayName,
    email,
    password,
  });
}

export async function logout(): Promise<void> {
  await postRaw<unknown>("/api/auth/logout");
}

export async function fetchMe(): Promise<User> {
  const response = await getAuth<AuthResponse>("/api/auth/me");
  return response.data;
}
